'use strict';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import {getCollection, getId} from '../../core-utilities/domain/ReduxUtils';


PermissionsVersionsService.$inject = [
  'AuthService',
  'FirebaseUtil',
  'FirebaseQueueService',
  'FirebaseConnectionService',
  'ROOT_API_COLLECTION',
  'ROOT_API_SPEC',
];

export function PermissionsVersionsService(
  AuthService,
  FirebaseUtil,
  FirebaseQueueService,
  FirebaseConnectionService,
  ROOT_API_COLLECTION,
  ROOT_API_SPEC,
) {
  const service = this;

  this.getCurrentVersions = getCurrentVersions;
  this.loadedPrivateData = loadedPrivateData;
  this.requestUpdate = __generate2ArgFn(__requestUpdateImpl);
  this.getAclVersion = __generate2ArgFn(__getAclVersionImpl);
  this.versionMatches = __generate2ArgFn(__versionMatchesImpl);

  /**
   *
   * @param {string} [target] - A valid ACL collection
   * @returns {Promise.<Object|string|null>}
   */
  function getCurrentVersions(target) {
    return FirebaseUtil.firebaseRef('_permissions-cache-versions')
      .once('value')
      .then(ss => {
        const versions = ss.val();
        if (!versions)
          return null;
        else
          return target ? versions[target] : versions;
      });
  }

  function loadedPrivateData(target, id) {
    const singleArg = arguments.length === 1;
    return service.versionMatches(target, id).then(function (matches) {
      if (!matches) {
        if (singleArg)
          return service.requestUpdate(target);
        else
          return service.requestUpdate(target, id);
      }
    });
  }

  function __requestUpdateImpl(collection, id) {
    if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});

    const request = {
      method: collection + '/acl/update',
      id: id,
    };

    try {
      return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  function __getAclVersionImpl(collection, id) {
    const userId = AuthService.getUserId();
    const path = collection + '-meta/' + id + '/acl/' + userId + '/_version';

    return FirebaseUtil.firebaseRef(path)
      .once('value')
      .then(ss => ss.val());
  }

  function __versionMatchesImpl(collection, id) {
    return Promise
      .props({
        currentVersion: getCurrentVersions(collection),
        aclVersion: __getAclVersionImpl(collection, id),
      })
      .then(__compareVersions);
  }

  function __compareVersions(data) {
    return data.currentVersion === data.aclVersion;
  }

  function __generate2ArgFn(impl) {
    return function fn(target, id) {
      if (arguments.length === 1) {
        if (!isObject(target) || !target.$class)
          return Promise.reject('target must be a valid permissions-enabled domain instance!');
        else
          return impl(getCollection(target), getId(target));
      } else if (arguments.length === 2) {
        if (!isString(target) || !isString(id))
          return Promise.reject('target and id must be strings!');
        else
          return impl(target, id);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/services/PermissionsVersionsService.js